"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function computeColorVal(alpha, baseColor, bgColor) {
  return Math.round((1 - alpha) * bgColor + alpha * baseColor);
}
/**
 * Converts a rgba color to its equivalent hex code for a given background color.
 */


function rgbaToHex(baseColor, backgroundColor) {
  return (0, _toColorString.default)({
    red: computeColorVal(baseColor.alpha, baseColor.red, backgroundColor.red),
    blue: computeColorVal(baseColor.alpha, baseColor.blue, backgroundColor.blue),
    green: computeColorVal(baseColor.alpha, baseColor.green, backgroundColor.green)
  });
}

var _default = rgbaToHex;
exports.default = _default;